var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbContactIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-2 -2 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#ib-contact-icon_svg__clip0_6723_16395)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 11C7.24 11 6 12.213 6 14a1 1 0 11-2 0c0-1.713.803-3.315 2.082-4.224a3 3 0 114.836 0C12.198 10.685 13 12.286 13 14a1 1 0 11-2 0c0-1.787-1.24-3-2.5-3zm0-2a1 1 0 100-2 1 1 0 000 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 20a4 4 0 004-4V4a4 4 0 00-4-4H2a2 2 0 00-2 2v16a2 2 0 002 2h11zm2-4a2 2 0 01-2 2H2V2h11a2 2 0 012 2v12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 5a1 1 0 10-2 0v6a1 1 0 102 0V5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ib-contact-icon_svg__clip0_6723_16395"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

export default SvgIbContactIcon;